import { Helmet } from 'react-helmet';

interface UkConvertTagProps {
  shopCountry?: string;
}

const UkConvertTag = (props: UkConvertTagProps) => {
  if (
    window.location.hostname !== 'booking.goboat.co.uk' &&
    (!props.shopCountry || props.shopCountry !== 'United Kingdom')
  ) {
    return null;
  }

  return (
    <Helmet>
      <script
        type="text/javascript"
        src="//cdn-4.convertexperiments.com/v1/js/10016447-10016946.js?environment=production"
      />
      <script>
        {`
          console.log('Fish n chips');
        `}
      </script>
    </Helmet>
  );
};

export default UkConvertTag;
